import { getOfficePolicies } from '../../../services/policyAPIs';

import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import PolicyCard from '../../../components/cards/PolicyCard';
import {generateWordDoc} from '../../../utils/downloadHelpers';
import {generatePDF} from '../../../utils/pdfGenerator';
import './style.css';
import {
  TextField,
} from '@mui/material';
import TypewriterButton from '../../../components/btns/TypewriterBtn';



// ==============================|| OFFICE POLICIES PAGE ||============================== //

// Default keywords
//const defaultFilters = ['Dress Code', 'Remote Work', 'Attendance'];
const defaultFilters = [];


const OfficePoliciesPage = () => {
  console.log(localStorage.getItem('userRole'));
  const navigate = useNavigate();
  const [allExpanded, setAllExpanded] = useState(false);
  const [policies, setPolicies] = useState([]);
  const [filters, setFilters] = useState(defaultFilters);
  const [newFilter, setNewFilter] = useState('');
  const [title, setTitle] = useState('Office Policies');
  const [downloadFormat, setDownloadFormat] = useState('pdf');
  const printRef = useRef();
  const up='op';

   useEffect(() => {
    const fetchPolicies = async () => {
      try {
        const data = await getOfficePolicies();
        setPolicies(data);
      } catch (error) {
        console.error('Failed to fetch policies', error);
      }
    };

    fetchPolicies();
  }, []);

  console.log(policies);

  // Updated handlePrint with contentRef
  const handlePrint = useReactToPrint({
    contentRef: printRef,  // Changed from content to contentRef
    documentTitle: 'Office Policies',
    onBeforeGetContent: () => {
      return new Promise(resolve => {
        setAllExpanded(true);
        setTimeout(resolve, 200);
      });
    },
    onAfterPrint: () => setAllExpanded(false),
    // Pdf Padding
    pageStyle: `
    @page { size: A4; }
      @media print {
        body {
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
        }
        .office-policies-container {
          padding-top: 5; 
          padding-bottom: 5;
          padding-left: 3;
          padding-right: 3;
        }
      }
    `
  });

  //Download
  const handleDownload = async () => {
    if (filteredPolicies.length === 0) {
      console.log('There is nothing to print/download');
      alert('There are no policies to download!');
      return;
    }

    // Ensure content is expanded before printing/downloading
    await new Promise(resolve => {
      setAllExpanded(true);
      setTimeout(resolve, 200);
    });

    const content = printRef.current;

    if (!content) {
      console.error('Content ref is null, cannot proceed with download/print.');
      alert('Content not ready for download. Please try again.');
      setAllExpanded(false);
      return;
    }

    if (downloadFormat === 'pdf') {
      // Clone node to avoid affecting live UI
      const clone = content.cloneNode(true);
      handlePrint();
    } else if (downloadFormat === 'word') {
      const htmlContent = content.outerHTML;
      generateWordDoc(htmlContent, title);
      setAllExpanded(false); // Collapse after Word download
    }
  };

  //Delete
  const handleDelete = (id) => {
    setPolicies(policies.filter(policy => policy.id !== id));
  };

  const handleAddFilter = () => {
    const trimmed = newFilter.trim();
    if (trimmed && !filters.includes(trimmed)) {
      setFilters((prev) => [...prev, trimmed]);
      setNewFilter('');
    }
  };
  const handleRemoveFilter = (keyword) => {
    setFilters((prev) => prev.filter((f) => f !== keyword));
  };

  const filteredPolicies = filters.length === 0
  ? policies
  : policies.filter((policy) =>
      filters.some((keyword) =>
        policy.title.toLowerCase().includes(keyword.toLowerCase()) ||
        policy.body.toLowerCase().includes(keyword.toLowerCase())
      )
    );

  const handleFilterClick = (keyword) => {
  setFilters((prevFilters) =>
    prevFilters.includes(keyword)
      ? prevFilters.filter((f) => f !== keyword)
      : [...prevFilters, keyword]
  );
};



  return (
    <>
      {/* <h1>Office Policies</h1> */}
       {/* Filters UI */}
      <div style={{ marginBottom: '1rem', marginTop: '0.5rem',display: 'flex', flexDirection: 'row', gap:'15px'}} className='office-policies-container'>
        <TypewriterButton text="Click here to start reading" color="white" onClick={() => navigate('/policy-viewer')} />
        <h3>Active Filters:</h3>
        {filters.map((filter) => (
        <div key={filter} style={{ position:'relative', gap:'15px'}}>
          <button
            
            onClick={() => handleFilterClick(filter)}
            style={{
              // margin: '4px',
              padding: '6px 12px',
              backgroundColor: '#eee',
              border: '1px solid #ccc',
              borderRadius: '12px',
              cursor: 'pointer'
            }}
          >
            {filter} 
          </button>
          <button
            onClick={() => handleRemoveFilter(filter)}
            style={{
              position:'absolute',
              top:'35%',
              left:'85%',
              cursor: 'pointer',
              background:'transparent',
              border:'none'
            }}
          >
           ❌
          </button>
          </div>
          
        ))}
        <TextField
          autoWidth
          label="Add a filter..."
          value={newFilter}
          // onChange={(e) => setTitle(e.target.value)}
          onChange={(e) => setNewFilter(e.target.value)}
          variant="outlined"
           sx={{
          '& .MuiInputBase-root': {
            height: '30px', // Fixed height
          },
          '& .MuiInputBase-input': {padding: '10px 14px'},
          '& .MuiInputLabel-root': { top: '-10px' },
        }}
        />
        <button onClick={handleAddFilter} className="filter-button">Add</button>
      </div>
      <div ref={printRef}>
        {filteredPolicies.map(policy => (
          <PolicyCard up={up} key={policy.id} id={policy.id} title={policy.title} body={policy.body} onDelete={handleDelete} imageUrls={policy.imageUrls}
            forceExpanded={allExpanded} 
          />  
        ))}
      </div>
      <div style={{ display: 'flex', gap: '10px', marginBottom: '20px',display:'flex', justifyContent:"flex-start"  }}>
        <div style={{ marginLeft:'auto', display: 'flex', gap: '10px'}}>
        <select
         className="styled-select"
        value={downloadFormat}
        onChange={(e) => setDownloadFormat(e.target.value)}
        >
          <option value="pdf">PDF</option>
          <option value="word">Word</option>
        </select>
        <button onClick={() => handleDownload()} className='filter-button'>Download</button>
      </div>
      
      </div>
    </>
  );
};

export default OfficePoliciesPage;